import * as Yup from 'yup';

export const messageFeedbackValidationSchema = () =>
    Yup.object().shape({
        details: Yup.string().notRequired(),
    });
